import React from 'react';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Tooltip } from '@material-ui/core';

import BookingSummary from './BookingSummary';
import BookingDetails from './BookingDetails';

import styles from './Booking.module.scss';
import { getPayoutTrafficColor, hasPayoutRatio } from '../../common/payout';

export default class Booking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      showFlag: false,
      hasCorruptStops: false
    };

    this.onClickAccordionSummary = this.onClickAccordionSummary.bind(this);
    this.onClickAccordionDetails = this.onClickAccordionDetails.bind(this);
    this.handleCorruptStops = this.handleCorruptStops.bind(this);
    this.corruptStopsDetected = false;
  }



  componentDidMount() {
    const { isExpanded } = this.props;
    this.setState({ isExpanded });
  }

  componentDidUpdate() {
    if (this.corruptStopsDetected && !this.state.hasCorruptStops) {
      this.corruptStopsDetected = false;
      this.setState({ hasCorruptStops: true });
    }
  }

  onClickAccordionSummary(booking) {
    this.props.onSelectBookingFunc(booking);
    let { isExpanded } = this.state;
    isExpanded = !isExpanded;

    this.setState({
      isExpanded: isExpanded,
    });
  }

  onClickAccordionDetails(booking) {
    this.props.onSelectBookingFunc(booking);
  }
  handleCorruptStops(hasCorruptStops) {
    this.corruptStopsDetected = hasCorruptStops;
  }

  render() {
    const { isExpanded } = this.state;
    const { booking, config, isOccasionBooking } = this.props;
    let showToolTip = true;
    if (!booking) {
      return null;
    }

    const route = booking.route || {};
    let percentage = booking.payoutRatio || 0;
    const bookingCountry = booking.currencyCode || 'AUD';
    const color = getPayoutTrafficColor(bookingCountry, percentage);
    // The unit-economics marker needs a payout ratio, and only root bookings are given
    // one (it is derived from the HQ event). A component booking has a route but no
    // ratio, so showing the marker there would both mislead and crash on toFixed —
    // its cost is shown on the occasion header instead.
    if (!booking.route || !hasPayoutRatio(booking)) {
      showToolTip = false;
    }
    return (
      <div className={styles.root} style={{ 
        position: 'relative',
        ...isOccasionBooking && {
          marginTop: 0,
          marginBottom: 0
        }
        }} ref={this.props.referenceProperty}>
        {showToolTip && (
          <Tooltip title={`${percentage.toFixed(2)}%`} placement='right'>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '20px',
              height: '20px',
              backgroundColor: color,
              clipPath: 'polygon(0 0, 0% 100%, 100% 0)',
              zIndex: 1,
              borderRadius: '5px'
            }}></div>
          </Tooltip>
        )}

        <Accordion
          elevation={isOccasionBooking ? 0 : 1}
          style={{
            borderColor: 'red',
            backgroundColor: 'white',
            width: '100%',
            justifyContent: 'space-between',
            fontSize: '13px',
            marginTop: isExpanded ? '0px !important' : "0px",
            borderRadius: '8px',
            ...(isExpanded && {
              borderWidth: '1px 1px 1px 4px',
              borderStyle: 'solid',
              borderColor:
                'rgb(224, 224, 224) rgb(224, 224, 224) rgb(224, 224, 224) rgb(76, 175, 80)',
              borderImage: 'initial',
              borderRadius: '8px',
            }),
            ...isOccasionBooking && {
              border: '1px solid rgb(224, 224, 224)',
              borderRadius: '8px'
            }
          }}
          className={`${styles.bookingAccordion} ${
              isExpanded ? styles.bookingAccordionExpanded : ""
            }`} expanded={isExpanded}
          >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            onClick={() => this.onClickAccordionSummary(booking)}
            style={{
              backgroundColor: 'transparent',
            }}
          >
            <BookingSummary
              booking={booking}
              users={this.props.users}
              isOccasionBooking={isOccasionBooking}
              onPreviewConfirmationFunc={this.props.onPreviewConfirmationFunc}
              onPreviewCodeFunc={this.props.onPreviewCodeFunc}
              onUpdateBookingManagerFunc={this.props.onUpdateBookingManagerFunc}
              onDeleteBookingManagerFunc={this.props.onDeleteBookingManagerFunc}
              onUpdateBookingDeliveryStatusFunc={this.props.onUpdateBookingDeliveryStatusFunc}
              onClickBookingNote={this.props.onClickBookingNote}
              getProductByIdFunc={this.props.getProductByIdFunc}
              hasCorruptStops={this.state.hasCorruptStops}
            />
          </AccordionSummary>
          <AccordionDetails
            style={{
              backgroundColor: '#f5f9fc',
              borderTop: '1px solid #e0e0e0'
            }}
            onClick={() => this.onClickAccordionDetails(booking)}
          >
            <BookingDetails
              config={config}
              booking={booking}
              route={route}
              notActiveItems={this.props.notActiveItems}
              onClickSetRouteFunc={this.props.onClickSetRouteFunc}
              onClickSetVirtualFunc={this.props.onClickSetVirtualFunc}
              onPreviewConfirmationFunc={this.props.onPreviewConfirmationFunc}
              onPreviewCodeFunc={this.props.onPreviewCodeFunc}
              onUpdateBookingItemPaymentFunc={this.props.onUpdateBookingItemPaymentFunc}
              onUpdateBookingItemActivityFunc={this.props.onUpdateBookingItemActivityFunc}
              onUpdateStopBookingNoteFunc={this.props.onUpdateStopBookingNoteFunc}
              onUpdateBookingItemPriceFunc={this.props.onUpdateBookingItemPriceFunc}
              onClickAddBookingStopFunc={this.props.onClickAddBookingStopFunc}
              onClickAddBookingStopSparkFunc={this.props.onClickAddBookingStopSparkFunc}
              onSelectStopFunc={this.props.onSelectStopFunc}
              googleMapURL={this.props.googleMapURL}
              onSwapStopsFunc={this.props.onSwapStopsFunc}
              onPublishBookingFunc={this.props.onPublishBookingFunc}
              onSelectBookingFunc={this.props.onSelectBookingFunc}
              onUpdatePersonalisationCheckFunc={this.props.onUpdatePersonalisationCheckFunc}
              handleCorruptStops={this.handleCorruptStops}
            />
          </AccordionDetails>
        </Accordion>
      </div >
    );
  }
}
